class MarqueeTextBlock extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      requestAnimationFrame(() => {
        if (document.fonts) {
          document.fonts.ready.then(() => this.calculateSpeed());
        } else {
          setTimeout(() => this.calculateSpeed(), 100);
        }
      });

      window.addEventListener('resize', this.debounce(this.calculateSpeed.bind(this), 200));
    }
  }

  calculateSpeed() {
    const group = this.querySelector('.marquee-group');
    if (!group) return;

    const width = group.offsetWidth;
    
    // Get speed setting
    const speedSetting = parseFloat(this.getAttribute('scrolling-speed')) || 10;
    const velocity = speedSetting * 10; 
    
    const duration = width / velocity;

    // 1. Set the correct speed
    this.closest('.scrolling-text-block').style.setProperty('--marquee-duration', `${duration}s`);
    
    // 2. ADD THIS LINE: Tell CSS we are ready to animate
    this.classList.add('is-loaded');
  }
  
  debounce(func, wait) {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
}

class ScrollingTextBlock extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      if (window.ScrollTimeline) {
        const timeline = new ViewTimeline({
          subject: this,
          axis: "block"
        });
        this.animate(
          { transform: ["translateX(0)", "translateX(-50%)"] },
          { timeline: timeline, rangeStart: "cover 0%", rangeEnd: "cover 100%" }
        );
      } else {
         window.addEventListener('scroll', () => {
           const rect = this.getBoundingClientRect();
           const percent = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
           if(percent >= 0 && percent <= 1) {
             this.style.transform = `translateX(${-50 * percent}%)`;
           }
         });
      }
    }
  }
}

if (!window.customElements.get("marquee-text-block")) {
  window.customElements.define("marquee-text-block", MarqueeTextBlock);
}

if (!window.customElements.get("scrolling-text-block")) {
  window.customElements.define("scrolling-text-block", ScrollingTextBlock);
}